import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Grid } from '@material-ui/core';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import { FormatListNumbered } from '@material-ui/icons';
import {
  useProdutoPizza,
  Tamanho,
} from '../../../../../../../hooks/produtoPizza';
import { useToast } from '../../../../../../../hooks/toast';
import { useAuth } from '../../../../../../../hooks/auth';

import api from '../../../../../../../services/api';

import { SubmitButtonWrapper } from '../../../../styles';
import {
  TabWrapper,
  TamanhoItem,
  TamanhoInput,
  ButtonAction,
  LabelWrapper,
} from '../../../drawer_styles';

const Tamanhos: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const {
    produtoId,
    produtoPizzaData,
    cloning,
    resetDrawer,
    changeProdutoPizzaData,
    enableComplementos,
    changeCurrentTabIndex,
  } = useProdutoPizza();
  const { addToast } = useToast();
  const { user } = useAuth();

  const [tamanhos, setTamanhos] = useState<Tamanho[]>([]);

  useEffect(() => {
    async function loadTamanhos(): Promise<void> {
      const response = await api.get('/tamanho');

      if (produtoId) {
        setTamanhos(
          response.data
            .filter((tamanho: any) => tamanho.ativo)
            .map((tamanho: any) => {
              const findTamanho = produtoPizzaData.tamanhos.find(
                (t) => t.id === tamanho.id,
              );

              if (findTamanho) {
                return {
                  ...findTamanho,
                  preco: findTamanho.preco,
                  codigo: cloning ? '' : findTamanho.codigo,
                };
              }

              return {
                ...tamanho,
                preco: 0,
                codigo: 0,
              };
            }),
        );
      } else {
        setTamanhos(
          response.data
            .filter((tamanho: any) => tamanho.ativo)
            .map((tamanho: any) => ({
              ...tamanho,
              isSelected: true,
              ordem: 1,
            })),
        );
      }
    }

    loadTamanhos();
  }, [user, cloning, produtoId, produtoPizzaData]);

  const handleSetTamanhoValue = useCallback(
    (id: number, field: string, value: any) => {
      const updatedTamanhos = tamanhos.map((tamanho) => {
        if (tamanho.id === id) {
          return {
            ...tamanho,
            [field]: value,
          };
        }

        return tamanho;
      });

      setTamanhos(updatedTamanhos);
    },
    [tamanhos],
  );

  const handleSubmit = useCallback(async () => {
    const dataIsCorrect = tamanhos
      .filter((tamanho) => tamanho.isSelected)
      .every((tamanho) => !isNaN(Number(tamanho.preco)));

    if (dataIsCorrect) {
      if (tamanhos.filter((tamanho) => tamanho.isSelected).length > 0) {
        let canSave = true;

        await Promise.all(
          tamanhos.map(async (tamanho) => {
            if (tamanho.codigo) {
              const hasCodeStored = await api.get(
                `/produto/${user.empresa_id}?codigo=${tamanho.codigo}&produto_id=${tamanho.produto_grade_id}`,
              );

              if (hasCodeStored.data) {
                addToast({
                  type: 'error',
                  title: `Já existe um produto cadastrado com o código PDV ${tamanho.codigo}.`,
                });

                canSave = false;
              }
            }
          }),
        );

        if (canSave) {
          changeProdutoPizzaData({ tamanhos });
          enableComplementos();
          changeCurrentTabIndex(2);
        }
      } else {
        addToast({
          title: 'Selecione pelo menos um tamanho!',
          type: 'error',
        });
      }
    } else {
      addToast({
        title: 'Preencha os dados corretamente!',
        type: 'error',
        description: 'Verifique os preços',
      });
    }
  }, [
    tamanhos,
    addToast,
    enableComplementos,
    changeCurrentTabIndex,
    changeProdutoPizzaData,
  ]);

  return (
    <TabWrapper>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <Grid container>
          <Grid container>
            {tamanhos.map((tamanho) => (
              <TamanhoItem key={tamanho.id} spacing={2} alignItems="center">
                <Grid item xs={2} style={{ display: 'flex', marginTop: 25 }}>
                  <input
                    type="checkbox"
                    name={`isSelected_${tamanho.id}`}
                    id={`isSelected_${tamanho.id}`}
                    checked={tamanho.isSelected}
                    onChange={(event) =>
                      handleSetTamanhoValue(
                        tamanho.id,
                        'isSelected',
                        event.target.checked,
                      )
                    }
                  />
                  <label htmlFor={`isSelected_${tamanho.id}`}>
                    {tamanho.descricao}
                  </label>
                </Grid>
                <Grid item xs={2}>
                  <LabelWrapper>
                    <span>Preço</span>
                  </LabelWrapper>

                  <TamanhoInput
                    type="number"
                    style={{ width: '100%' }}
                    defaultValue={tamanho.preco}
                    placeholder="Preço"
                    min={0}
                    step=".001"
                    onChange={(event) =>
                      handleSetTamanhoValue(
                        tamanho.id,
                        'preco',
                        Number(event.target.value),
                      )
                    }
                  />
                </Grid>
                <Grid item xs={2}>
                  <LabelWrapper>
                    <span>Cód. PDV</span>
                  </LabelWrapper>

                  <TamanhoInput
                    type="text"
                    style={{ width: '100%' }}
                    defaultValue={tamanho.codigo}
                    placeholder="Cód. PDV"
                    onChange={(event) =>
                      handleSetTamanhoValue(
                        tamanho.id,
                        'codigo',
                        event.target.value,
                      )
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <LabelWrapper>
                    <span>Estoque Mín.</span>
                  </LabelWrapper>

                  <TamanhoInput
                    type="number"
                    style={{ width: '100%' }}
                    defaultValue={tamanho.estoque_minimo}
                    placeholder="Estoque Mín."
                    min={0}
                    step=".001"
                    onChange={(event) =>
                      handleSetTamanhoValue(
                        tamanho.id,
                        'estoque_minimo',
                        Number(event.target.value),
                      )
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <LabelWrapper>
                    <span>Estoque Atual</span>
                  </LabelWrapper>

                  <TamanhoInput
                    type="number"
                    style={{ width: '100%' }}
                    defaultValue={tamanho.estoque_atual}
                    placeholder="Estoque Atual"
                    min={0}
                    step=".001"
                    onChange={(event) =>
                      handleSetTamanhoValue(
                        tamanho.id,
                        'estoque_atual',
                        Number(event.target.value),
                      )
                    }
                  />
                </Grid>
              </TamanhoItem>
            ))}
          </Grid>
          <Grid item xs={12} style={{ marginTop: 50 }}>
            <SubmitButtonWrapper>
              <ButtonAction
                type="button"
                className="cancel"
                onClick={resetDrawer}
              >
                Cancelar
              </ButtonAction>
              <ButtonAction type="submit" className="submit" id="submit_button">
                Continuar
              </ButtonAction>
            </SubmitButtonWrapper>
          </Grid>
        </Grid>
      </Form>
    </TabWrapper>
  );
};

export default Tamanhos;
